import React, { useState, useEffect } from "react";
import Card from "./Card";

export default function Category(props) {
  const [toggle, setToggle] = useState(false);
  const [hide, setHide] = useState("hide");
  const [active, setActive] = useState("active");
  const handleCategoryClick = e => {
    setToggle(!toggle);
  };

  useEffect(() => {
    checkToggle();
  });

  const checkToggle = () => {
    if (toggle) {
      setHide("show");
      setActive("active");
    } else {
      setHide("hide");
      setActive("inactive");
    }
  };
  console.log(props.codes)
  return (
    <>
      <button
        className={`${active} constrainedButton`}
        variant="contained"
        onClick={handleCategoryClick}
      >
        {props.category}
      </button>
      <div className="constrainedCard">
        <div className={hide}>
          {Object.entries(props.codes.category[props.section]).map(
            (item, i) => {
              return (
                <div key={ i } className="flexCards">
                  <Card
                    key={i + props.codes}
                    codes={props.codes}
                    section={props.section}
                    img={item[1].img}
                    code={item[1].code}
                    darkLogo={item[1].darkLogo}
                    darkBackground={item[1].darkBackground}
                    googlePlayLink={item[1].googlePlayLink}
                    appStoreLink={item[1].appStoreLink}
                    googlePlay={props.codes.googlePlay}
                    appStore={props.codes.appStore}
                    link={item[1].link}
                  />
                </div>
              );
            }
          )}
        </div>
      </div>
    </>
  );
}
